import Icon from '../Icon.vue'

Icon.register({
  'dot': {
    width: 21,
    height: 20,
    paths: [
      {
        d: 'M10 5V2.824L12.176 5H10zm.003-5H1a1 1 0 00-1 1v18a1 1 0 001 1h13a1 1 0 001-1v-3h-2v2H2V2h6v4a1 1 0 001 1h4v2h2V4.997L10.003 0z'
      },
      {
        d: 'M10.354 11.398c-.112-.168-.28-.28-.59-.28h-.538v2.801h.539c.308 0 .476-.112.588-.28.098-.139.133-.272.133-1.12 0-.84-.035-.98-.133-1.12zm.84 3.124c-.344.343-.827.49-1.345.49h-1.85v-4.986h1.85c.518 0 1.002.146 1.345.49.581.581.517 1.22.517 2.003 0 .784.064 1.422-.518 2.003zM14.645 11.294a.615.615 0 00-.49-.218.61.61 0 00-.49.218c-.113.146-.183.314-.183 1.226 0 .91.07 1.07.183 1.218.09.119.265.224.49.224a.619.619 0 00.49-.224c.112-.147.181-.308.181-1.218 0-.912-.07-1.08-.181-1.226zm.902 3.2c-.364.364-.784.56-1.393.56-.61 0-1.03-.196-1.393-.56-.525-.525-.505-1.225-.505-1.974 0-.75-.02-1.451.505-1.976.363-.364.784-.56 1.394-.56.609 0 1.029.196 1.393.56.525.525.504 1.226.504 1.976 0 .749.021 1.449-.505 1.974zM18.774 11.118v3.895h-1.227v-3.895h-1.225v-1.092H20v1.092h-1.226z'
      }
    ]
  }
})
